import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { listUploads } from '../../services/tools';
import { useAuth } from '../../contexts/AuthContext';

// Bibliothèque d'images réutilisable : ouvre une galerie des photos téléversées ;
// un clic sur une image la sélectionne (onSelect).
export const ImageLibrary = ({ open, onOpenChange, onSelect }) => {
  const { token } = useAuth();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        setLoading(true); setError('');
        const data = await listUploads(token);
        setImages(data.images || []);
      } catch (e) {
        setError(e.response?.data?.detail || e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [open, token]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl" data-testid="image-library-dialog">
        <DialogHeader>
          <DialogTitle>Bibliothèque d'images</DialogTitle>
          <DialogDescription>Cliquez sur une photo pour l'utiliser. Toutes vos photos téléversées apparaissent ici.</DialogDescription>
        </DialogHeader>
        {error && <p className="text-sm text-red-600">{error}</p>}
        {loading ? (
          <p className="text-sm text-muted-foreground py-8 text-center">Chargement…</p>
        ) : images.length === 0 ? (
          <p className="text-sm text-muted-foreground py-8 text-center">Aucune image téléversée pour l'instant.</p>
        ) : (
          <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 max-h-[60vh] overflow-y-auto pr-1">
            {images.map((img) => (
              <button
                key={img.url}
                type="button"
                data-testid="library-image"
                onClick={() => { onSelect(img.url); onOpenChange(false); }}
                className="group relative aspect-square rounded-md overflow-hidden border border-border hover:ring-2 hover:ring-primary transition"
                title={img.name}
              >
                <img src={img.url} alt={img.name} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
              </button>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ImageLibrary;
